export const IS_SAVED_BOOK = 'IS_SAVED_BOOK';
export const SET_SAVE_BOOK_FLAG = 'SET_SAVE_BOOK_FLAG';



// WEBPACK FOOTER //
// ./src/redux/action-types/ui/isSavedBook.js